import { Dialog as MuiDialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

import { ConfirmDialogProps } from './dialog.types';

import { Button } from '../../inputs/button/button.component';
import { LoadingOverlay } from '../loading-overlay';

export const ConfirmDialog = (props: ConfirmDialogProps) => {
  const {
    children,
    dialogTitle,
    open,
    onClose,
    declineButtonText = 'Cancel',
    confirmButtonText,
    confirmButtonProps,
    declineButtonProps,
    showLoadingOverlay,
    ...rest
  } = props;

  const { color = 'primary', loading, ...restConfirmButtonProps } = confirmButtonProps;

  return (
    <MuiDialog open={open} onClose={onClose} {...rest}>
      {dialogTitle && <DialogTitle>{dialogTitle}</DialogTitle>}
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button variant='text' size='medium' onClick={onClose} {...declineButtonProps}>
          {declineButtonText}
        </Button>
        {loading ? (
          <LoadingButton
            {...restConfirmButtonProps}
            variant='contained'
            size='medium'
            color={color}
            loading={loading}
          >
            {confirmButtonText}
          </LoadingButton>
        ) : (
          <Button {...restConfirmButtonProps} variant='contained' size='medium' color={color}>
            {confirmButtonText}
          </Button>
        )}
      </DialogActions>
      {showLoadingOverlay && <LoadingOverlay loaderSize={32}></LoadingOverlay>}
    </MuiDialog>
  );
};
